import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=10b35d12&scoped=true&lang=html&"
import script from "./AdminDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=10b35d12&prod&lang=css&"
import style1 from "./AdminDashboard.vue?vue&type=style&index=1&id=10b35d12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b35d12",
  null
  
)

export default component.exports